export default __webpack_public_path__ + "media/images/logo/logo-1tvch-en-c58f77322b20176776d8bd2b49cbb345.svg";